import { createTheme, MantineColorsTuple } from "@mantine/core";

const sea: MantineColorsTuple = [
  "#e7f8ff",
  "#d1ecff",
  "#a3d6fe",
  "#71befe",
  "#4cabfd",
  "#37b6ff",
  "#2aa1f3",
  "#1c8bdc",
  "#0a78c5",
  "#005fa1",
];

const sun: MantineColorsTuple = [
  "#fffbe6",
  "#fff5c2",
  "#ffeb8a",
  "#ffe16c",
  "#ffde59",
  "#f5cc3a",
  "#dab32a",
  "#b6951f",
  "#947814",
  "#6e5908",
];

const blossom: MantineColorsTuple = [
  "#ffe8f5",
  "#ffd0e7",
  "#ff9ed0",
  "#ff6cba",
  "#fe66c4",
  "#ee4cb1",
  "#d33b9a",
  "#b22e81",
  "#8d2467",
  "#671a4c",
];

export const villaTheme = createTheme({
  primaryColor: "sea",
  primaryShade: { light: 5, dark: 4 },
  colors: {
    sea,
    sun,
    blossom,
  },
  defaultRadius: "lg",
  fontFamily:
    '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontFamilyMonospace:
    '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
  headings: {
    fontFamily: '"Fraunces", "Cormorant Garamond", Georgia, serif',
    fontWeight: "600",
    sizes: {
      h1: {
        fontSize: "clamp(2.25rem, 5vw, 3.75rem)",
        lineHeight: "1.05",
        fontWeight: "600",
      },
      h2: { fontSize: "clamp(1.75rem, 3.5vw, 2.5rem)", lineHeight: "1.15" },
      h3: { fontSize: "clamp(1.4rem, 2.5vw, 1.875rem)", lineHeight: "1.25" },
      h4: { fontSize: "1.25rem", lineHeight: "1.35" },
    },
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
  },
  spacing: {
    xs: "0.5rem",
    sm: "0.75rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2.5rem",
  },
  radius: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "18px",
    xl: "28px",
  },
  shadows: {
    xs: "0 1px 2px rgba(15, 41, 76, 0.06)",
    sm: "0 4px 14px rgba(15, 41, 76, 0.08)",
    md: "0 10px 30px rgba(15, 41, 76, 0.12)",
    lg: "0 20px 50px rgba(15, 41, 76, 0.18)",
    xl: "0 30px 80px rgba(15, 41, 76, 0.22)",
  },
  cursorType: "pointer",
  components: {
    Button: {
      defaultProps: {
        radius: "xl",
      },
    },
    Card: {
      defaultProps: {
        radius: "lg",
        shadow: "sm",
      },
    },
    Modal: {
      defaultProps: {
        radius: "lg",
        centered: true,
        overlayProps: { backgroundOpacity: 0.55, blur: 4 },
      },
    },
    Paper: {
      defaultProps: {
        radius: "lg",
      },
    },
  },
});
